<mat-card [formGroup]="formGroupDetails" appearance="outlined">
  <mat-tab-group mat-stretch-tabs (selectedTabChange)="onSelected($event)">
    <mat-tab label="Termin-Informationen">
      <mat-card-content>
        <span class="row">
          <mat-form-field>
            <mat-label>
              {{ "MAIN_APP_SERVICE_APP.datum" | translate }}
            </mat-label>
            <input matInput [matDatepicker]="picker" [id]="fldDatumKey" [formControlName]="fldDatumKey" required />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </span>

        <span class="row">
          <mat-form-field>
            <mat-label>{{"MAIN_APP_SERVICE_APP.startzeit" | translate}}</mat-label>
            <input type="time" matInput [formControlName]="fldStartzeitKey" [id]="fldStartzeitKey" />
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{"MAIN_APP_SERVICE_APP.endzeit" | translate}}</mat-label>
            <input type="time" matInput [formControlName]="fldEndzeitKey" [id]="fldEndzeitKey" />
          </mat-form-field>
        </span>

        <span class="row">
          <mat-form-field>
            <mat-label class="font">{{"MAIN_APP_SERVICE_APP.notizenEinsatz" | translate
              }}</mat-label>
            <textarea matInput maxlength="255" cdkTextareaAutosize cdkAutosizeMinRows="4" [formControlName]="fldNotizenKey" [id]="fldNotizenKey"></textarea>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{"MAIN_APP_SERVICE_APP.zusätzlicheArbeiten" | translate}}</mat-label>
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" [formControlName]="fldZusArbeitenKey" [id]="fldZusArbeitenKey" [(ngModel)]="currTermin.additionalWork"></textarea>
          </mat-form-field>
        </span>

        <span class="row" style="width: 100%;">
          <mat-form-field *ngIf="isManuDescRichText() === false">
            <mat-label>{{"MAIN_APP_SERVICE_APP.produktionsbeschrieb" | translate}}</mat-label>
            <textarea matInput [formControlName]="fldProdDescKey" [id]="fldProdDescKey" readonly="true"></textarea>
          </mat-form-field>

          <div *ngIf="isManuDescRichText() === true" style="display: flex; flex-direction: column; width: 100%;">
            <mat-label style="margin: 6px">{{ "MAIN_APP_SERVICE_APP.produktionsbeschrieb" | translate}}</mat-label>
            <ejs-richtexteditor #richTxtEditor1 id="iframeRTE1" [formControlName]="fldProdDescKey" [readonly]="true" [toolbarSettings]="{enable:false}" style="width: 100%;">
            </ejs-richtexteditor>
          </div>
        </span>
      </mat-card-content>
    </mat-tab>
    <mat-tab label="Termin-Adressen">
      <div style="display: flex">
        <mat-card appearance="outlined" style="flex: 1">
          <mat-card-content>
            <div style="display: flex; flex-direction: row; gap: 0.5em;">
              <div *ngIf="kundeDetail">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.kunde" | translate }}
                </div>
                <div class="row" *ngIf="kundeDetail.name">
                  <mat-icon>person</mat-icon> <span>{{kundeDetail.name}}</span>
                </div>
                <div class="row" *ngIf="kundeDetail.adresse">
                  <mat-icon>house</mat-icon> <span>{{kundeDetail.adresse}}</span>
                </div>
                <div class="row" *ngIf="kundeDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ kundeDetail.phone1 }}">{{kundeDetail.phone1}}</a></span>
                </div>
                <div class="row" *ngIf="kundeDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ kundeDetail.phone2 }}">{{kundeDetail.phone2}}</a></span>
                </div>
                <div class="row" *ngIf="kundeDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ kundeDetail.mobile1 }}">{{kundeDetail.mobile1}}</a></span>
                </div>
                <div class="row" *ngIf="kundeDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ kundeDetail.mobile2 }}">{{kundeDetail.mobile2}}</a></span>
                </div>
                <div class="row" *ngIf="kundeDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ kundeDetail.mail1 }}">{{kundeDetail.mail1}}</a></span>
                </div>
                <div class="row" *ngIf="kundeDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ kundeDetail.mail2 }}">{{kundeDetail.mail2}}</a></span>
                </div>
              </div>


              <div *ngIf="kundeKontaktDetail.name">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.ansprechpartner" | translate }}
                </div>
                <div *ngIf="kundeKontaktDetail.name">
                  <mat-icon>person</mat-icon><span>{{kundeKontaktDetail.name}}</span>
                </div>
                <div *ngIf="kundeKontaktDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ kundeKontaktDetail.phone1 }}">{{kundeKontaktDetail.phone1}}</a></span>
                </div>
                <div *ngIf="kundeKontaktDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ kundeKontaktDetail.phone2 }}">{{kundeKontaktDetail.phone2}}</a></span>
                </div>
                <div *ngIf="kundeKontaktDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ kundeKontaktDetail.mobile1 }}">{{kundeKontaktDetail.mobile1}}</a></span>
                </div>
                <div *ngIf="kundeKontaktDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ kundeKontaktDetail.mobile2 }}">{{kundeKontaktDetail.mobile2}}</a></span>
                </div>
                <div *ngIf="kundeKontaktDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ kundeKontaktDetail.mail1 }}">{{kundeKontaktDetail.mail1}}</a></span>
                </div>
                <div *ngIf="kundeKontaktDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ kundeKontaktDetail.mail2 }}">{{kundeKontaktDetail.mail2}}</a></span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" style="flex: 1">
          <mat-card-content>
            <div style="display: flex; flex-direction: row; gap: 0.5em;">
              <div *ngIf="rechnungDetail">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.rechnungsadresse" | translate }}
                </div>
                <div class="row" *ngIf="rechnungDetail.name">
                  <mat-icon>person</mat-icon><span>{{rechnungDetail.name}}</span>
                </div>
                <div class="row" *ngIf="rechnungDetail.adresse">
                  <mat-icon>house</mat-icon><span>{{rechnungDetail.adresse}}</span>
                </div>
                <div class="row" *ngIf="rechnungDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ rechnungDetail.phone1 }}">{{rechnungDetail.phone1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ rechnungDetail.phone2 }}">{{rechnungDetail.phone2}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ rechnungDetail.mobile1 }}">{{rechnungDetail.mobile1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ rechnungDetail.mobile2 }}">{{rechnungDetail.mobile2}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ rechnungDetail.mail1 }}">{{rechnungDetail.mail1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ rechnungDetail.mail2 }}">{{ rechnungDetail.mail2 }}"></a></span>
                </div>
              </div>

              <div *ngIf="rechnungKontaktDetail">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.ansprechpartner" | translate }}
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.name">
                  <mat-icon>person</mat-icon><span>{{rechnungKontaktDetail.name}}</span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ rechnungKontaktDetail.phone1 }}">{{rechnungKontaktDetail.phone1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ rechnungKontaktDetail.phone2 }}">{{rechnungKontaktDetail.phone2}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ rechnungKontaktDetail.mobile1 }}">{{rechnungKontaktDetail.mobile1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ rechnungKontaktDetail.mobile2 }}">{{rechnungKontaktDetail.mobile2}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ rechnungKontaktDetail.mail1 }}">{{rechnungKontaktDetail.mail1}}</a></span>
                </div>
                <div class="row" *ngIf="rechnungKontaktDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ rechnungKontaktDetail.mail2 }}">{{rechnungKontaktDetail.mail2}}</a></span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div style="display: flex">
        <mat-card appearance="outlined" style="flex: 1">
          <mat-card-content>
            <div style="display: flex; flex-direction: row; gap: 0.5em;">
              <div *ngIf="lieferantDetail">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.lieferadresse" | translate }}
                </div>
                <div class="row" *ngIf="lieferantDetail.name">
                  <mat-icon>person</mat-icon><span>{{lieferantDetail.name}}</span>
                </div>
                <div class="row" *ngIf="lieferantDetail.adresse">
                  <mat-icon>house</mat-icon><span>{{lieferantDetail.adresse}}</span>
                </div>
                <div class="row" *ngIf="lieferantDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ lieferantDetail.phone1 }}">{{lieferantDetail.phone1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ lieferantDetail.phone2 }}">{{lieferantDetail.phone2}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ lieferantDetail.mobile1 }}">{{lieferantDetail.mobile1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ lieferantDetail.mobile2 }}">{{lieferantDetail.mobile2}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ lieferantDetail.mail1 }}">{{lieferantDetail.mail1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ lieferantDetail.mail2 }}">{{ lieferantDetail.mail2 }}"></a></span>
                </div>
              </div>
              <div *ngIf="lieferantKontaktDetail">
                <div class="row" *ngIf="lieferantKontaktDetail.name">
                  {{ "MAIN_APP_SERVICE_APP.ansprechpartner" | translate }}
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.name">
                  <mat-icon>person</mat-icon><span>{{lieferantKontaktDetail.name}}</span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.phone1">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ lieferantKontaktDetail.phone1 }}">{{lieferantKontaktDetail.phone1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.phone2">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ lieferantKontaktDetail.phone2 }}">{{lieferantKontaktDetail.phone2}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.mobile1">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ lieferantKontaktDetail.mobile1 }}">{{lieferantKontaktDetail.mobile1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ lieferantKontaktDetail.mobile2 }}">{{lieferantKontaktDetail.mobile2}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.mail1">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ lieferantKontaktDetail.mail1 }}">{{lieferantKontaktDetail.mail1}}</a></span>
                </div>
                <div class="row" *ngIf="lieferantKontaktDetail.mail2">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ lieferantKontaktDetail.mail2 }}">{{lieferantKontaktDetail.mail2}}</a></span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined" style="flex: 1">
          <mat-card-content>
            <div style="display: flex; flex-direction: row; gap: 0.5em;">
              <div *ngIf="architektKontaktDetail">
                <div class="row">
                  {{ "MAIN_APP_SERVICE_APP.architekt" | translate }}
                </div>
                <div *ngIf="architektDetail.name" class="row">
                  <mat-icon>person</mat-icon><span>{{architektDetail.name}}</span>
                </div>
                <div *ngIf="architektDetail.adresse" class="row">
                  <mat-icon>house</mat-icon><span>{{architektDetail.adresse}}</span>
                </div>
                <div *ngIf="architektDetail.phone1" class="row">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ architektDetail.phone1 }}">{{architektDetail.phone1}}</a></span>
                </div>
                <div *ngIf="architektDetail.phone2" class="row">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ architektDetail.phone2 }}">{{architektDetail.phone2}}</a></span>
                </div>
                <div *ngIf="architektDetail.mobile1" class="row">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ architektDetail.mobile1 }}">{{architektDetail.mobile1}}</a></span>
                </div>
                <div *ngIf="architektDetail.mobile2">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ architektDetail.mobile2 }}">{{architektDetail.mobile2}}</a></span>
                </div>
                <div *ngIf="architektDetail.mail1" class="row">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ architektDetail.mail1 }}">{{architektDetail.mail1}}</a></span>
                </div>
                <div *ngIf="architektDetail.mail2" class="row">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ architektDetail.mail2 }}">{{ architektDetail.mail2 }}"></a></span>
                </div>
              </div>
              <div *ngIf="architektKontaktDetail">
                <div *ngIf="architektKontaktDetail.name" class="row">
                  {{ "MAIN_APP_SERVICE_APP.ansprechpartner" | translate }}
                </div>
                <div *ngIf="architektKontaktDetail.name" class="row">
                  <mat-icon>person</mat-icon><span>{{architektKontaktDetail.name}}</span>
                </div>
                <div *ngIf="architektKontaktDetail.phone1" class="row">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ architektKontaktDetail.phone1 }}">{{architektKontaktDetail.phone1}}</a></span>
                </div>
                <div *ngIf="architektKontaktDetail.phone2" class="row">
                  <mat-icon>call</mat-icon><span><a href="tel:{{ architektKontaktDetail.phone2 }}">{{architektKontaktDetail.phone2}}</a></span>
                </div>
                <div *ngIf="architektKontaktDetail.mobile1" class="row">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ architektKontaktDetail.mobile1 }}">{{architektKontaktDetail.mobile1}}</a></span>
                </div>
                <div *ngIf="architektKontaktDetail.mobile2" class="row">
                  <mat-icon>smartphone</mat-icon><span><a href="tel:{{ architektKontaktDetail.mobile2 }}">{{architektKontaktDetail.mobile2}}</a></span>
                </div>
                <div *ngIf="architektKontaktDetail.mail1" class="row">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ architektKontaktDetail.mail1 }}">{{architektKontaktDetail.mail1}}</a></span>
                </div>
                <div *ngIf="architektKontaktDetail.mail2" class="row">
                  <mat-icon>email</mat-icon><span><a href="mailto:{{ architektKontaktDetail.mail2 }}">{{architektKontaktDetail.mail2}}</a></span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
    <mat-tab label="Kommentare">
      <mat-card-content>
        <mat-form-field appearance="fill" *ngIf="!isSaMemoRichText() === true">
          <mat-label>{{"MAIN_APP_SERVICE_APP.bestehendeKommentare" | translate}}</mat-label>
          <textarea matInput [formControlName]="fldMemoKey" [id]="fldMemoKey" readonly="true" style="min-height: 100px;"></textarea>
        </mat-form-field>


        <mat-form-field appearance="fill" *ngIf="isSaMemoRichText() === false">
          <mat-label>{{"MAIN_APP_SERVICE_APP.neuenKommentarErfassen" | translate}}</mat-label>
          <textarea matInput [formControlName]="fldMemoAddKey" [id]="fldMemoKey" style="min-height: 100px;"></textarea>
        </mat-form-field>

        <div *ngIf="isSaMemoRichText() === true">
          <mat-label>{{"MAIN_APP_SERVICE_APP.bestehendeKommentare" | translate}}</mat-label>
          <ejs-richtexteditor #richTxtEditor2 id="iframeRTE2" [height]="height" [formControlName]="fldMemoKey" [readonly]="true" [toolbarSettings]="{enable: false}" style="min-height: 100px;">
          </ejs-richtexteditor>
          <mat-label>{{
            "MAIN_APP_SERVICE_APP.neuenKommentarErfassen" | translate
            }}</mat-label>
          <ejs-richtexteditor #richTxtEditor3 id="iframeRTE3" [height]="height" [formControlName]="fldMemoAddKey" style="min-height: 100px;">
          </ejs-richtexteditor>
        </div>
      </mat-card-content>
    </mat-tab>
  </mat-tab-group>


  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroupDetails.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>

    <button mat-stroked-button class="cancel" (click)="delEinsatz()" [disabled]="!currTermin.createdInVinavon" [innerText]="'MAIN_APP_SERVICE_APP.löschen'| translate"></button>
  </mat-dialog-actions>

</mat-card>
